// extracted by mini-css-extract-plugin
export default {"wrapper":"login__wrapper__F_TzF","header":"login__header__OcMIf","logo":"login__logo__koTkz","sso":"login__sso__SlqYe","help":"login__help__dpi1G"};